<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-end">
                <div class="col-sm mb-2 mb-sm-0">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb breadcrumb-no-gutter">
                            <li class="breadcrumb-item"><router-link class="breadcrumb-link" to="/">Kokpit</router-link>
                            </li>
                            <li class="breadcrumb-item"><router-link class="breadcrumb-link"
                                    to="/client">Klienci</router-link></li>
                            <li class="breadcrumb-item active" aria-current="page">{{ $route.params.id }}</li>
                        </ol>
                    </nav>
                    <h1 class="page-header-title">Lista SMS: {{ $route.params.id }}</h1>
                </div>
            </div>
        </div>
        <!-- End Page Header -->

        <div class="card shadow-sm border-0">
            <div class="card-header border-bottom-0">
                <h4 class="card-header-title">Ostatnie wiadomości</h4>
            </div>

            <div class="table-responsive">
                <table
                    class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table">
                    <thead class="thead-light">
                        <tr>
                            <th style="width: 50px;">#</th>
                            <th>Data</th>
                            <th>Odbiorca</th>
                            <th>Treść wiadomości</th>
                            <th class="text-end">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in items" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                                <div class="d-flex flex-column">
                                    <span class="text-dark fw-bold">{{ formatDate(item.created_at.date) }}</span>
                                    <small class="text-muted">{{ formatTime(item.created_at.date) }}</small>
                                </div>
                            </td>
                            <td>
                                <span class="badge bg-soft-secondary text-secondary">
                                    <i class="bi-phone me-1"></i> {{ isAdmin ? item.sms_to : $maskPhone(item.sms_to) }}
                                </span>
                            </td>
                            <td>
                                <div class="text-wrap" style="max-width: 400px;">
                                    {{ isAdmin ? item.sms_body : $maskSms(item.sms_body) }}
                                </div>
                            </td>
                            <td class="text-end">
                                <span v-if="item.status === 'sent'"
                                    class="badge bg-soft-success text-success rounded-pill">Wysłano</span>
                                <span v-else-if="item.status === 'test'"
                                    class="badge bg-soft-info text-info rounded-pill">Test</span>
                                <span v-else-if="item.status === 'error'"
                                    class="badge bg-soft-danger text-danger rounded-pill">Błąd</span>
                                <span v-else class="badge bg-soft-warning text-warning rounded-pill">{{ item.status ||
                                    'Oczekiwanie' }}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="items.length === 0" class="card-body text-center py-5">
                <i class="bi-chat-dots display-1 text-muted opacity-25"></i>
                <p class="mt-3">Brak wysłanych wiadomości dla tego klienta.</p>
            </div>
        </div>
    </div>
</template>

<script>
import panelApi from '../../api/panel-axios.js';
import appConfig from '../../config.js';
import dayjs from 'dayjs';

export default {
    name: 'ClientSms',
    data() {
        return {
            items: [],
            loading: false
        }
    },
    computed: {
        isAdmin: function () {
            return ['owner', 'manager'].includes(this.$store.getters['app/role'])
        }
    },
    methods: {
        load() {
            this.loading = true;
            panelApi.get(appConfig.panelApiPrefix + '/sms/client/' + this.$route.params.id + '/messages').then(response => {
                this.items = response.data.data || [];
                this.loading = false;
            }).catch(err => {
                console.error(err);
                this.loading = false;
            });
        },
        formatDate(dateStr) {
            return dayjs(dateStr).format('YYYY-MM-DD');
        },
        formatTime(dateStr) {
            return dayjs(dateStr).format('HH:mm:ss');
        }
    },
    mounted() {
        this.load();
    }
}
</script>

<style scoped>
.text-wrap {
    white-space: normal !important;
    word-break: break-all;
}

.bg-soft-success {
    background-color: rgba(0, 201, 167, 0.1) !important;
}

.bg-soft-danger {
    background-color: rgba(237, 76, 120, 0.1) !important;
}

.bg-soft-warning {
    background-color: rgba(245, 202, 153, 0.1) !important;
}

.bg-soft-secondary {
    background-color: rgba(113, 119, 125, 0.1) !important;
}
</style>